export default __webpack_public_path__ + "static/media/remove-icon.268813c8.svg";